export const paymentMethodProps = () => ({
  isAllowCarteCarrefour: {
    type: Boolean,
    required: false,
  },
  isServiceCompatibleEuroCarrefour: {
    type: Boolean,
    required: false,
  },
  isFidCarrefour: {
    type: Boolean,
    required: false,
  },
  hasCarteCarrefour: {
    type: Boolean,
    required: false
  },
  leftToPay: {
    type: [String, Number],
    required: true
  },
  selected: {
    type: Boolean,
    required: false,
    default: false
  },
  carteCarrefourPayment: {
    type: Boolean,
    required: false,
    default: false
  },
  disabled: {
    type: Boolean,
    required: false,
    default: false
  },
  montantTotalTtc: {
    type: [String, Number],
    required: true
  },
  paymentMethod: {
    type: Object,
    required: false,
    default() {
      return null;
    }
  },
  paymentMethodInfos: {
    type: Object,
    required: false,
    default() {
      return null;
    }
  },
  useDiscount: {
    type: Boolean,
    required: false,
    default: false
  },
  cardsRegistered: {
    type: Boolean,
    required: false,
    default: false
  },
  isPorteurCarteCora: {
    type: Boolean,
    required: true
  },
  carteCoraIsMalinPlus: {
    type: Boolean,
    required: false,
    default: false
  },
  isPorteurCarteMalin: {
    type: Boolean,
    required: false,
    default: false
  },
  isLoading: {
    type: Boolean,
    required: false,
    default: false
  },
  tirelire: {
    type: Object,
    required: false,
    default: null
  },
  restrictionAge: {
    type: Boolean,
    required: false,
    default: false
  },
  displayEuroCora: {
    type: Boolean,
    required: false,
    default: false
  },
  produitsIncompatibles: {
    type: Array,
    required: false,
    default: () => []
  },
  aliasPaiement: {
    type: Array,
    required: false,
    default: () => []
  },
  aliasMaxParMagasin: {
    type: Number,
    required: false,
    default: 0
  },
  isEligibleAliasPaiement: {
    type: Boolean,
    required: false,
    default: false
  },
  hasAliasInOtherMagasin: {
    type: Boolean,
    required: false,
    default: false
  },
  isEligibleDefis: {
    type: Boolean,
    required: false,
    default: false
  },
  warning: {
    type: Object,
    required: false,
    default: null
  },
  magasinName: {
    type: String,
    required: false,
    default: null
  }
})

export const paymentMethodEmits = () => ([
  "click",
  "processPaiement",
  "openPopinMultiPay"
]);

export const usePaymentMethod = (props, context, popinUseEuroCora) => {
  const euroCoraADeduire = ref(0)
  const isMajeur = ref(false)
  const isInputedEuroCora = ref(false)
  const validerDisabled = ref(false)
  const aliasPaiementSelected = ref(undefined)

  const useEuroCora = (val) => {
    euroCoraADeduire.value = val;
  }
  const cancelUseEuroCora = () => {
    euroCoraADeduire.value = 0;
  }
  const updateAliasPaiement = (idAliasPaiement) => {
    aliasPaiementSelected.value = idAliasPaiement
  }
  const processPaiement = () => {
    const params = {}
    if(props.displayEuroCora && (isInputedEuroCora.value && !euroCoraADeduire.value)) {
      popinUseEuroCora.value.show()
      return;
    }
    if (props.tirelire) {
      params.tirelire = {
        montant: euroCoraADeduire.value,
        carte: props.tirelire.carte
      }
    }
    if (aliasPaiementSelected.value !== undefined) {
      params.alias_paiement_id = aliasPaiementSelected.value
    }
    context.emit('processPaiement', params);
  }
  const setInputStatus = (input) => {
    if(input === "" || !input) {
      isInputedEuroCora.value = false
    } else {
      isInputedEuroCora.value = true
    }
  }
  const select = () => {
    if (!props.selected) {
      context.emit("click");
    }
  }
  const openPopinMultiPay = (echeancier) => {
    context.emit("openPopinMultiPay", echeancier)
  }
  const paymentMethodId = computed(() => {
    return props.paymentMethod.mode_paiement;
  })
  const paymentMethodIsCarteCora = computed(() => {
    return paymentMethodId.value === "cora";
  })
  const typeCarteEuroCora = computed(() => {
    return props.tirelire ? props.tirelire.type : "";
  })
  const montantEuroCora = computed(() => {
    return props.tirelire ? parseFloat(props.tirelire.montant) : 0;
  })
  const showEcheancier = computed(() => {
    return props.paymentMethod.code_paiement_simulateur
  })
  const nouveau = computed(() => {
    return props.paymentMethod.is_new;
  })
  const disabledComputed = computed(() => {
    return props.disabled || !props.paymentMethodInfos.possible || (props.isCarteKdoEnCours && !props.carteKdo)
  })
  const aliasNotSelected = computed(() => {
    return paymentMethodId.value === "cb" && props.aliasPaiement.length > 0 && props.isEligibleAliasPaiement && aliasPaiementSelected.value === undefined
  })

  return {
    euroCoraADeduire,
    isMajeur,
    validerDisabled,
    aliasPaiementSelected,
    useEuroCora,
    cancelUseEuroCora,
    updateAliasPaiement,
    processPaiement,
    select,
    openPopinMultiPay,
    paymentMethodId,
    paymentMethodIsCarteCora,
    typeCarteEuroCora,
    montantEuroCora,
    showEcheancier,
    nouveau,
    disabledComputed,
    aliasNotSelected,
    isInputedEuroCora,
    setInputStatus
  }
}